import styled from 'styled-components'
import { Row, Container } from '../Globals/index'
import { sizes } from '@theme'

export const InsightDetailsContainer = styled(Container)`
  width: 55%;
  margin: 40px auto;
`

export const ListItems = styled.li`
  margin-top: 3%;
`

export const QuoteContainer = styled(Row)`
  padding: 7%;
  background-color: #f3f3f3;
  line-height: 2rem;
  margin: 0 auto;
  margin-top: 40px;
`

export const CardsAndArticleContainer = styled(Container)`
  max-width: 770px;
  flex-direction: ${({ flexDirection }) => (flexDirection ? 'column' : 'row')};
  ${({ justifyContent }) =>
    justifyContent && { 'justify-content': 'space-between' }};
  display: flex;
  margin: 0;
  @media (max-width: ${sizes.medium.max}) {
    width: 480px;
  }

  @media (max-width: ${sizes.medium.min}) {
    width: 100%;
    flex: 0 0 100%;
    margin: 0 auto 40px;
  }

  @media (max-width: ${sizes.xsmall.max}) {
    width: 100%;
    flex: 0 0 100%;
    margin: 0 auto 40px;
  }

  @media (min-width: ${sizes.large.min}) {
    max-width: 610px;
    flex: 0 0 66.667%;
  }

  @media (min-width: 1200px) {
    width: 100%;
    max-width: 770px;
    margin-left: 20px;
  }
`

export const RowContainer = styled(Row)`
  width: ${({ width }) => (width ? '80%' : '100%')};
  margin-right: ${({ marginRight }) => marginRight || '0px'};
  margin-left: ${({ marginLeft }) => marginLeft || '0px'};

  @media (min-width: 500px) {
    width: 100%;
  }
  @media (min-width: 768px) {
    max-width: 720px;
    width: 575px;
    margin-bottom: 40px;
    // padding-left: 15px;
    // padding-right: 15px;
  }
  @media (min-width: 992px) {
    max-width: 960px;
    width: 760px;
  }
  @media (min-width: 1280px) {
    max-width: 1200px;
    width: 950px;
  }
`
